import { UsePageFilters } from 'store/pagesFilters/types';
import { DirectSalesDealManagementFilters } from '../Filters.types';

export const DATE_FILTER_KEYS = ['createdAt', 'dropDate'] as const;
export type DateFilterKey = (typeof DATE_FILTER_KEYS)[number];

export const TEXT_FILTER_KEYS = ['updatedBy', 'createdBy'] as const;
export type TextFilterKey = (typeof TEXT_FILTER_KEYS)[number];

export const isDateFilterKey = (key: string | null): key is DateFilterKey =>
  key !== null && (DATE_FILTER_KEYS as readonly string[]).includes(key);

export const isTextFilterKey = (key: string | null): key is TextFilterKey =>
  key !== null && (TEXT_FILTER_KEYS as readonly string[]).includes(key);

export interface AdvancedFiltersProps {
  changeFilters: UsePageFilters<DirectSalesDealManagementFilters>['changeFilters'];
  clearAllButton?: React.ReactNode;
  filters: Pick<
    DirectSalesDealManagementFilters,
    | 'salesTeam'
    | 'salesPerson'
    | 'adminPerson'
    | 'advertiser'
    | 'brand'
    | 'productCategory'
    | 'agency'
    | 'specialist'
    | 'updatedBy'
    | 'createdBy'
    | 'createdAt'
    | 'dropDate'
  >;
}
